// import useFacebookAuthentication from "./useFacebookAuthentication";
import { trackLogin } from "@/utils/loginTracking";
import type { SocialProvider } from "@/utils/loginTracking";

import useGoogleAuthentication from "./useGoogleAuthentication";
import useLinkedInAuthentication from "./useLinkedInAuthentication";

const useSocialLogin = () => {
  const { googleUser, handleGoogleBtnClick, isGoogleLoading } =
    useGoogleAuthentication();
  const { linkedInUser, handleLinkedInBtnClick, isLinkedInLoading } =
    useLinkedInAuthentication();
  // const { facebookUser, handleFacebookLogin } = useFacebookAuthentication();

  const handleSocialLogin = (type: "google" | "linkedin" | "facebook") => {
    // Track social login with centralized utility
    const provider = (type.charAt(0).toUpperCase() +
      type.slice(1)) as SocialProvider;

    trackLogin({
      loginMethod: "Social",
      credentialType: "social",
      socialProvider: provider,
    });

    switch (type) {
      case "google":
        handleGoogleBtnClick();
        break;
      // case "facebook":
      //   handleFacebookLogin();
      //   break;
      case "linkedin":
        handleLinkedInBtnClick();
        break;
      default:
        handleGoogleBtnClick();
        break;
    }
  };

  return {
    socialUser: googleUser || linkedInUser,
    handleSocialLogin,
    isLoading: { google: isGoogleLoading, linkedin: isLinkedInLoading },
  };
};

export default useSocialLogin;
